import { render, staticRenderFns } from "./YoutubeModal.vue?vue&type=template&id=8980a644&"
import script from "./YoutubeModal.vue?vue&type=script&lang=js&"
export * from "./YoutubeModal.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports